import { fetchMe } from "@/api/auth";
import type { AuthState } from "@/types/developer";
import {
    createContext,
    useContext,
    useEffect,
    useState,
    type ReactNode,
} from "react";

interface AuthCtx extends AuthState {
  refresh: () => Promise<void>;
}

const AuthContext = createContext<AuthCtx>({
  role: "guest",
  refresh: async () => {},
});

export function AuthProvider({ children }: { children: ReactNode }) {
  const [auth, setAuth] = useState<AuthState>({ role: "guest" });

  const refresh = async () => {
    try {
      const me = await fetchMe();
      setAuth(me);
    } catch {
      setAuth({ role: "guest" });
    }
  };

  useEffect(() => {
    void refresh();
  }, []);

  return (
    <AuthContext.Provider value={{ ...auth, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
